import _ from 'lodash';

export default function getAllDataInParallel({ fn, key } = {}) {
  return new Promise((resolve, reject) => {
    let data = []
    let cacheChecksum
    const resolveData = ({
      data: d = [],
      cacheChecksum: c,
      key: k,
    }) => {
      resolve(
        _.omitBy({
          [k]: d,
          count: _.size(d),
          cacheChecksum: c,
          query: _.get(_.first(d), 'query'),
        }, _.isUndefined)
      )
    }
    const fetchData = (otherPagesFn) => {
      const fetchNext = _.isFunction(otherPagesFn)
        ? otherPagesFn
        : () => fn({ pageCountless: false, pageSize: 999 })
      fetchNext()
        .then((result) => {
          // first page result
          if (_.has(result, key)) {
            const pageData = _.get(result, key, [])
            data = [
              ...data,
              ...pageData,
            ]
            cacheChecksum = _.get(result, 'cacheChecksum')
          }
          // other pages result
          if (_.isArray(result)) {
            data = [
              ...data,
              ..._.flatMap(result, key),
            ]
            cacheChecksum = _.get(_.last(result), 'cacheChecksum')
            resolveData({ data, cacheChecksum, key })
          }
          // use `all` function to fetch other pages at once
          const all = _.get(result, 'all')
          if (_.isFunction(all)) {
            fetchData(all)
          } else {
            resolveData({ data, cacheChecksum, key })
          }
        })
        .catch(reject)
    }

    fetchData()
  })
}
